<template>
  <div class="home-child-wrapper" ref="pageContainer">
    <el-container>
      <!-- <el-aside :width="profileWith">
        <div class="right-aside">
          <div class="profile-wrapper" v-loading="profileShade">
            <UserProfile :profile="userProfile" :profileMenu="profileMenu" />
          </div>
        </div>
      </el-aside> -->
      <!-- <el-header>
        <div class="feed-type-title">
          <span>{{ initDetailTitle }}</span>
        </div>
      </el-header> -->
      <el-main>
        <div class="feed-wrapper" :class="wrapClass" v-loading="detailShade">
          <div class="feed-type-title">
            <span>{{ initDetailTitle }}</span>
          </div>
          <div class="feed-container">
            <div class="header-wrapper">
              <!-- <FeedHeader :feed="feed" :scene="feedScene" /> -->
              <div class="feed-header flex">
                <div>
                  <UserAvatar
                    :src="
                      feed.userInfo.thumbHeadImg || feed.userInfo.headImgUrl
                    "
                    :userType="initType"
                  />
                </div>
                <div class="feed-info flex">
                  <div class="name-wrapper">
                    <p class="user-name">
                      {{
                        feed.userInfoExtend ||
                          feed.username ||
                          feed.userInfo.name
                      }}
                    </p>
                    <p class="create-time">{{ date }}</p>
                  </div>
                  <div class="header-action-wrapper" v-if="notMine">
                    <el-dropdown
                      placement="bottom"
                      trigger="click"
                      @command="handleAcation"
                    >
                      <span class="arrow-down-wrapper">
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="1">举报</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div class="repot-form-wrapper">
                  <el-dialog
                    title="举报"
                    :visible.sync="dialogVisible"
                    :before-close="handleClose"
                    custom-class="handlian-report-container"
                    width="540px"
                  >
                    <el-form
                      :model="ruleForm"
                      :rules="rules"
                      ref="ruleForm"
                      label-width="100px"
                      class="demo-ruleForm"
                    >
                      <el-form-item label="举报原因" prop="reasonId">
                        <el-radio-group v-model="ruleForm.reasonId">
                          <el-radio
                            v-for="(item, index) in reasonList"
                            :key="index"
                            :label="item.id"
                            >{{ item.reason }}</el-radio
                          >
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="其他原因" prop="reason">
                        <el-input
                          type="textarea"
                          v-model="ruleForm.reason"
                          resize="none"
                          maxlength="100"
                          show-word-limit
                          :autosize="{ minRows: 2 }"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="联系方式" prop="contact">
                        <el-input
                          type="text"
                          v-model="ruleForm.contact"
                          placeholder="请留下您的手机号 或 传联号"
                        ></el-input>
                      </el-form-item>
                      <p class="report-tip">请放心，你的隐私将会得到保护。</p>
                      <el-form-item>
                        <el-button
                          class="handlian-btn"
                          type="primary"
                          @click="submitForm('ruleForm')"
                          >立即举报</el-button
                        >
                        <el-button
                          class="handlian-btn"
                          @click="resetForm('ruleForm')"
                          >重置</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                </div>
              </div>
            </div>
            <div class="body-wrapper">
              <div class="feed-body">
                <div class="feed-title">{{ initFeedTitle }}</div>
                <div class="feed-summary">{{ initDetailContent }}</div>
                <div
                  class="admin-feed-container"
                  v-html="adminFeedContent"
                ></div>
                <ArticleElement
                  v-if="isCommonArticle"
                  :feed="feed"
                  :scene="feedScene"
                />
                <AlbumElement
                  v-if="feed.modelType == FEED_TYPES.ALBUM"
                  :feed="feed"
                  :scene="feedScene"
                />
                <AudioElement
                  v-if="feed.modelType == FEED_TYPES.AUDIO"
                  :feed="feed"
                />
                <VideoElement
                  v-if="feed.modelType == FEED_TYPES.VIDEO"
                  :feed="feed"
                />
                <AdminVideoElement v-if="isAdminVideo" :feed="feed" />
              </div>
            </div>
            <div class="footer-wrapper">
              <div class="feed-footer">
                <div class="feed-handle">
                  <ul class="hl_row_line flex">
                    <li>
                      <span class="handle-text">浏览</span>
                      <span class="handle-count">{{ viewCount }}</span>
                    </li>
                    <li>
                      <a href="javascript:;" @click="switchComment">
                        <span class="handle-icon comment"></span>
                        <span class="handle-count">{{ commentCount }}</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;" @click="praiseFeed">
                        <span class="handle-icon" :class="praiseStatus"></span>
                        <span class="handle-count">{{ praiseCount }}</span>
                      </a>
                    </li>
                    <li>
                      <!-- <a href="javascript:;" v-intervalclick='{func:dissFeed,time:5000}'> -->
                      <a href="javascript:;" @click="dissFeed">
                        <span class="handle-icon" :class="dissStatus"></span>
                        <span class="handle-count">{{ dissCount }}</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;" @click="switchShare">
                        <span class="handle-icon share"></span>
                      </a>
                    </li>
                  </ul>
                  <span class="triangle" v-if="unfoldComment"></span>
                  <span class="share-triangle" v-show="foldShare"></span>
                </div>
                <div class="feed-comment" v-if="unfoldComment">
                  <div class="comment-list" v-loading="commentShade">
                    <CommentItem
                      v-for="(comment, index) in commentList"
                      :key="index"
                      :comment="comment"
                      :replyList="comment.replyData"
                      :replyCount="comment.replyData.length"
                      :deleteStatus="comment.isDeleted"
                      :showStatus="comment.isShow"
                      @handleDelete="deleteComment"
                      @handleReload="reloadCommentList"
                    />
                    <p class="no-comment" v-if="commentList.length == 0">
                      {{ noCommentText }}
                    </p>
                    <div class="pagination-wrapper">
                      <el-pagination
                        layout="prev, pager, next"
                        :total="totalPage"
                        prev-text="上一页"
                        next-text="下一页"
                        hide-on-single-page
                        @current-change="curCommentPageClick"
                      ></el-pagination>
                      <!-- @prev-click="prevCommentPageClick" @next-click="nextCommentPageClick"-->
                    </div>
                  </div>
                  <div class="comment-box">
                    <div class="input-wrapper">
                      <el-input
                        type="textarea"
                        resize="none"
                        maxlength="100"
                        show-word-limit
                        :autosize="{ minRows: 2 }"
                        placeholder="评论..."
                        v-model="commentContent"
                      ></el-input>
                    </div>
                    <div class="comment-btn flex">
                      <span></span>
                      <el-button
                        class="send-comment"
                        :disabled="forbidComment"
                        @click="submitComment"
                        >发表</el-button
                      >
                    </div>
                  </div>
                </div>
                <div class="share-feed-wrap flex" v-show="foldShare">
                  <div class="share-text">分享至</div>
                  <div>
                    <ul class="share-menu flex">
                      <li v-for="(item, index) in shareMenu" :key="index">
                        <a
                          href="javascript:;"
                          :class="item.icon"
                          @click="initShareFeed(item.command)"
                          >{{ item.name }}</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ShareHandLian />
        <PhotoPreviewer />
        <AvatarPreviewer />
      </el-main>
    </el-container>
    <div class="message-aside">
      <MessageMenu />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../utils/apiMap";
import FeedItem from "../components/friend/feed-item";
import UserProfile from "../components/UserProfile";
import UserAvatar from "../components/UserAvatar";
import PhotoPreviewer from "../components/PhotoPreviewer";
import AvatarPreviewer from "../components/AvatarPreviewer";
import MessageMenu from "../components/message-aside/message-menu";
import FeedHeader from "../components/friend/feed-header";
import FeedFooter from "../components/friend/feed-footer";
import ArticleElement from "../components/friend/feed-elements/article-element";
import AlbumElement from "../components/friend/feed-elements/album-element";
import AudioElement from "../components/friend/feed-elements/audio-element";
import VideoElement from "../components/friend/feed-elements/video-element";
import AdminVideoElement from "../components/community/feed-elements/admin-video-element";
import ShareHandLian from "../components/ShareHandLian";
import CommentItem from "../components/friend/comment-item";
import { tranNumber, htmlFilter, isInternetUrl } from "../utils/feed";
import { getFullDate } from "../utils/date";
export default {
  name: "detail",
  data() {
    var validateContact = (rule, value, callback) => {
      var numberRegExp = /^[0-9]+$/;
      if (value !== "") {
        if (!numberRegExp.test(value)) {
          callback(new Error("联系方式只能是数字"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      isCommonArticle: true,
      isAdminVideo: false,
      profileShade: true,
      detailShade: true,
      userProfile: {},
      feed: {
        userInfo: {
          headImgUrl: "",
        },
        // support: 0,
        // thread: 0
      },
      adminFeedContent: "",
      feedScene: "feedDetail",
      profileMenu: {
        linkBtn: true,
        addFriendBtn: false,
        copyTreeBtn: false,
        modifyTreeBrn: false,
        apllyTreeBtn: false,
        setRemarkBtn: false,
      },
      commentTotal: 0,
      unfoldComment: false,
      praised: false,
      dissed: false,
      commentShade: true,
      commentList: [],
      commentTotal: 0,
      curCommentPage: 1,
      forbidComment: true,
      commentContent: "",
      noCommentText: "",
      foldShare: false,
      shareMenu: [{ name: "传联好友", command: 1, icon: "share-handlian" }],
      notMine: true,
      dialogVisible: false,
      clearDialog: true,
      initType: 1,
      reasonList: [],
      ruleForm: {
        reasonId: "",
        reason: "",
        contact: "",
      },
      rules: {
        reasonId: [
          { required: true, message: "请选择举报原因", trigger: "change" },
        ],
        reason: [{ required: false, trigger: "blur" }],
        contact: [{ validator: validateContact, trigger: "blur" }],
      },
    };
  },
  components: {
    FeedItem,
    UserAvatar,
    UserProfile,
    PhotoPreviewer,
    AvatarPreviewer,
    MessageMenu,
    FeedHeader,
    FeedFooter,
    ArticleElement,
    AlbumElement,
    AudioElement,
    VideoElement,
    AdminVideoElement,
    ShareHandLian,
    CommentItem,
  },
  computed: {
    ...mapGetters(["contactBook", "contactsList"]),
    profileWith() {
      if (this.feed.userType == 1) {
        return "340px";
      } else {
        return "0";
      }
    },
    wrapClass() {
      if (this.feed.userType == 2) {
        return "admin-feed";
      }
    },
    initDetailTitle() {
      switch (this.feed.modelType) {
        case "1":
          return "文章详情";
        case "2":
          return "相册详情";
        case "3":
          return "音频详情";
        case "4":
          return "视频详情";
        default:
          return "动态详情";
      }
    },
    initFeedTitle() {
      return htmlFilter(this.feed.title);
    },
    date() {
      return getFullDate(new Date(this.feed.created_at * 1000));
    },
    initDetailContent() {
      if (this.feed.userType == 1) {
        if (this.feed.modelType == 1) {
          return htmlFilter(this.feed.content);
        } else {
          if (this.feed.introduction != "null") {
            return htmlFilter(this.feed.introduction);
          }
        }
      }
    },
    viewCount() {
      if (this.feed && this.feed.readCount) {
        return tranNumber(this.feed.readCount);
      } else {
        return "0";
      }
    },
    commentCount() {
      if (this.feed && this.feed.commentCount) {
        return tranNumber(this.feed.commentCount);
      } else {
        return "0";
      }
    },
    praiseCount() {
      if (this.feed && this.feed.upCount) {
        return tranNumber(this.feed.upCount);
      } else {
        return "0";
      }
    },
    dissCount() {
      if (this.feed && this.feed.downCount) {
        return tranNumber(this.feed.downCount);
      } else {
        return "0";
      }
    },
    praiseStatus() {
      if (this.praised == true) {
        return "praised";
      } else {
        return "unpraise";
      }
    },
    dissStatus() {
      if (this.dissed == true) {
        return "dissed";
      } else {
        return "undiss";
      }
    },
    totalPage() {
      return this.commentTotal;
    },
  },
  beforeMount() {
    // console.log(this.$route.query)
    this.getFeedDetail();
  },
  mounted() {
    this.$refs.pageContainer.style.minHeight = `${document.documentElement.clientHeight}px`;
  },
  methods: {
    getFeedDetail() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            token: loginUser.token,
            modelId: _this.$route.query.feedID,
            modelType: _this.$route.query.feedType,
            self: 2,
          },
        })
        .then(function(response) {
          // console.log(response.data.result.data);
          if (response.data.result.statusCode == 1) {
            _this.feed = response.data.result.data;
            _this.detailShade = false;
            if (response.data.result.data.support == 1) {
              _this.praised = true;
            } else {
              _this.praised = false;
            }
            if (response.data.result.data.thread == 1) {
              _this.dissed = true;
            } else {
              _this.dissed = false;
            }
            // _this.getAuthorProfile(response.data.result.data.userId);
            _this.getFriendList();
            _this.initType = response.data.result.data.userType;
            // if (response.data.result.data.userType == 2) {
            //   _this.adminFeedContent = response.data.result.data.content;
            // }
            if (response.data.result.data.userId !== loginUser.userId) {
              _this.notMine = true;
            } else {
              _this.notMine = false;
            }
            var typeArr = ["1"];
            if (response.data.result.data.userType == 1) {
              _this.isAdminVideo = false;
              _this.isCommonArticle = typeArr.includes(_this.feed.modelType)
                ? true
                : false;
            } else {
              _this.isCommonArticle = false;
              _this.isAdminVideo = isInternetUrl(_this.feed.craw_uri)
                ? true
                : false;
              if (!isInternetUrl(_this.feed.craw_uri)) {
                _this.adminFeedContent = response.data.result.data.content;
              }
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAuthorProfile(userId) {
      // console.log(loginUser)
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["userProfile"]["method"],
          url: apiMap["userProfile"]["url"],
          data: `token=${loginUser.token}&userId=${userId}`,
        })
        .then(function(response) {
          // console.log(response.data.result.data);
          if (response.data.result.statusCode == 1) {
            _this.userProfile = response.data.result.data;
            _this.profileShade = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getFriendList() {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["friendsList"]["method"],
        url: apiMap["friendsList"]["url"],
        data: "token=" + loginUser.token,
      })
        .then(function(response) {
          // console.log(response.data);
          if (response.data.result.statusCode == 1) {
            let newList = response.data.result.data.filter((item) => {
              return item.userId != loginUser.userId;
            });
            let friendGroup = ["朋友"];
            let contactList = new Array();
            let contactBook = new Array();
            newList.forEach((item) => {
              let remark = "";
              let displayHeadImg = Store.state.defaultAvatar.C2C;
              var groupIndex = friendGroup.indexOf(item.group);
              if (groupIndex == -1 && item.group != "null") {
                friendGroup.push(item.group);
              }
              if (item.group == "null") {
                item.group = "朋友";
              }
              if (item.thumbHeadImg) {
                displayHeadImg = item.thumbHeadImg;
              } else if (item.headImgUrl) {
                displayHeadImg = item.headImgUrl;
              }
              if (item.markInfo) {
                remark = item.markInfo.mark;
              }
              item.avatar = displayHeadImg;
              item.remark = remark;
              contactList.push(item);
            });
            friendGroup.forEach((element) => {
              let item = {
                name: element,
                member: contactList.filter((friend) => friend.group == element),
              };
              contactBook.push(item);
            });
            Store.dispatch("setContactList", contactList);
            Store.dispatch("setFriendGroup", friendGroup);
            Store.dispatch("setContactBook", contactBook);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    switchComment() {
      // console.log(this.feed)
      if (this.unfoldComment == false) {
        this.unfoldComment = true;
        this.foldShare = false;
        this.getCommentList(1);
      } else {
        this.unfoldComment = false;
        (this.commentList = []), (this.commentShade = true);
      }
    },
    praiseFeed() {
      // var originPraise = this.feed.upCount;
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var modelType = _this.feed.modelType;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["praiseFeed"]["method"],
          url: apiMap["praiseFeed"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${_this.feed.modelId}&praiseType=1`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data == 1) {
              _this.praised = true;
              _this.feed.upCount += 1;
            } else {
              _this.feed.upCount -= 1;
              _this.praised = false;
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    dissFeed() {
      // var originDiss = this.feed.downCount;
      let _this = this;
      var modelType = _this.feed.modelType;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["praiseFeed"]["method"],
          url: apiMap["praiseFeed"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${_this.feed.modelId}&praiseType=2`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data == 1) {
              _this.dissed = true;
              _this.feed.downCount += 1;
            } else {
              _this.feed.downCount -= 1;
              _this.dissed = false;
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    switchShare() {
      if (this.foldShare == false) {
        this.unfoldComment = false;
        this.foldShare = true;
      } else {
        this.foldShare = false;
      }
    },
    deleteComment(commentID) {
      var findIndex = -1;
      this.commentList.filter((item, index) => {
        if (item.id == commentID) {
          findIndex = index;
        }
      });
      if (findIndex != -1) {
        this.commentList.splice(findIndex, 1);
        this.feed.commentCount -= 1;
      }
    },
    getCommentList(start) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var modelType = _this.feed.modelType;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["commentsList"]["method"],
          url: apiMap["commentsList"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${_this.feed.modelId}&start=${start}&count=10`,
        })
        .then(function(response) {
          _this.commentShade = false;
          if (response.data.result.statusCode == 1) {
            _this.commentTotal = response.data.result.count;
            _this.feed.commentCount = response.data.result.count;
            _this.commentList = response.data.result.data;
          } else {
            _this.noCommentText = "暂无评论";
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    prevCommentPageClick(newPage) {
      //即将加载的起始页
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    curCommentPageClick(newPage) {
      //即将加载的起始页
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    nextCommentPageClick(newPage) {
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    reloadCommentList() {
      this.getCommentList(this.curCommentPage);
    },
    submitComment() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var modelType = _this.feed.modelType;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["publishComment"]["method"],
          url: apiMap["publishComment"]["url"],
          data: `token=${loginUser.token}&modelType=${modelType}&modelId=${_this.feed.modelId}&content=${_this.commentContent}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var myComment = {
              content: _this.commentContent,
              created_at: Math.round(new Date() / 1000),
              id: response.data.result.data.commentId,
              isDeleted: 0,
              isShow: 1,
              modelId: _this.feed.modelId,
              modelType: _this.feed.article,
              ownerUserId: _this.feed.userId,
              praise: 0,
              praiseStatus: 0,
              replyCount: 0,
              replyData: Array(0),
              updated_at: null,
              userId: loginUser.userId,
              userInfo: {
                headImgUrl: loginUser.headImgUrl,
                name: loginUser.nickName,
                realName: "",
                thumbHeadImg: loginUser.thumbHeadImg,
              },
              userInfoExtend: loginUser.nickName,
            };
            _this.commentList.push(myComment);
            _this.commentContent = "";
            _this.feed.commentCount += 1;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initShareFeed(action) {
      switch (action) {
        case 1:
          this.openFriendList();
          break;
      }
    },
    openFriendList() {
      // console.log(this.contactBook)
      // console.log(this.contactsList)
      let _this = this;
      if (_this.contactBook != 0 && this.contactsList != 0) {
        _this.tryGetDetail((res) => {
          if (res.status == 1) {
            _this.$bus.$emit("open-share-contacts", JSON.stringify(res.data));
          } else {
            var tipHandle = "该动态没有分享到社区，不能分享给好友";
            _this.$message({
              message: tipHandle,
            });
          }
        });
      } else {
        _this.$message({
          message: "暂无传联好友",
        });
      }
    },
    tryGetDetail(okCbk) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var model =
        this.scene == "feedList" ? this.feed.article : this.feed.modelType;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            token: loginUser.token,
            modelId: _this.feed.modelId,
            modelType: model,
          },
        })
        .then(function(response) {
          // console.log(response.data.result.data);
          if (response.data.result.statusCode == 1) {
            var res = {
              status: 1,
              data: response.data.result.data,
            };
            okCbk(res);
          } else {
            var res = {
              status: 0,
              data: {},
            };
            okCbk(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.reportThisFeed(this.ruleForm);
          this.dialogVisible = false;
          this.resetForm("ruleForm");
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.resetForm("ruleForm");
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleAcation(action) {
      switch (action) {
        case 1:
          //举报
          this.getReportOption((result) => {
            if (result.statusCode == 1) {
              this.reasonList = result.data;
              this.dialogVisible = true;
            } else {
              this.$message({
                message: "获取举报原因失败，暂不能举报",
                duration: 1500,
                offset: 230,
              });
            }
          });
          break;
      }
    },
    reportThisFeed(fromData) {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var modelType =
        this.scene == "feedList" ? $this.feed.article : this.feed.modelType;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["reportFeed"]["method"],
          url: apiMap["reportFeed"]["url"],
          data: `token=${loginUser.token}&modelId=${this.feed.modelId}&modelType=${modelType}&reasonId=${fromData.reasonId}&contact=${fromData.contact}&reason=${fromData.reason}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            $this.$message({
              message: "操作成功！",
              type: "success",
              duration: 1500,
              offset: 230,
            });
          } else {
            $this.$message({
              message: "操作失败，稍后再试",
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getReportOption(cb) {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["reportReasons"]["method"],
        url: apiMap["reportReasons"]["url"],
        params: {
          token: loginUser.token,
        },
      })
        .then(function(response) {
          cb(response.data.result);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    navigateToUserCenter() {
      if (this.feed.userType == 1) {
        if (this.feed.userId) {
          this.$router.push({
            path: "/feed",
            query: {
              id: this.feed.userId,
            },
          });
        }
      }
    },
  },
  watch: {
    commentContent(text) {
      if (text === "" || text.trim().length === 0) {
        this.forbidComment = true;
      } else {
        this.forbidComment = false;
      }
    },
  },
};
</script>
<style scoped>
.home-child-wrapper {
  min-height: 80%;
}

.profile-wrapper {
  min-height: 280px;
  background-color: #fff;
}

.feed-wrapper {
  width: 840px;
  margin: 20px auto 20px;
}

.feed-type-title {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background-color: #1a70db;
}

.feed-wrapper.admin-feed {
  margin: 20px auto 20px;
}

.feed-container {
  padding: 15px;
  background-color: #fff;
}

.feed-body {
  margin: 10px 0 15px 55px;
}

.feed-summary {
  width: 730px;
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  color: #333;
  white-space: pre-wrap;
}

.feed-summary.media-feed {
  margin-bottom: 10px;
}

.feed-title {
  line-height: 30px;
  font-weight: bold;
  font-size: 16px;
  color: #333;
}

.feed-handle {
  position: relative;
}

.hl_row_line {
  justify-content: space-between;
}

.hl_row_line li {
  width: 23%;
  height: 25px;
  line-height: 25px;
}

.handle-text {
  color: #999999;
}

.hl_row_line li:last-child {
  width: 25px;
}

.handle-icon {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 19px;
  height: 17px;
  background-repeat: no-repeat;
  background-size: contain;
}

.handle-count {
  margin-left: 5px;
  color: #e74f52;
}

.comment {
  background-image: url("../assets/icon/cl_feed_comment.png");
}

.unpraise {
  background-image: url("../assets/icon/cl_feed_praise.png");
}

.praised {
  background-image: url("../assets/icon/cl_feed_praised.png");
}

.undiss {
  background-image: url("../assets/icon/cl_feed_diss.png");
}

.dissed {
  background-image: url("../assets/icon/cl_feed_dissed.png");
}

.share {
  background-image: url("../assets/icon/cl_feed_share.png");
}

.feed-comment {
  border: 1px solid #ebebeb;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  background: #fff;
  margin-top: 7px;
  overflow: visible;
  border-radius: 4px;
}

.feed-handle .triangle {
  position: absolute;
  top: 17px;
  left: 196px;
  height: 0;
  width: 0;
  content: "";
  z-index: 1;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #ebebeb;
}

.share-feed-wrap {
  padding: 6px;
  margin-top: 7px;
  font-size: 12px;
  overflow: visible;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
}

.feed-handle .share-triangle {
  position: absolute;
  top: 17px;
  right: 9px;
  height: 0;
  width: 0;
  content: "";
  z-index: 1;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #ebebeb;
}

.comment-list {
  min-height: 50px;
}

.comment-box {
  padding: 6px 10px;
  border-top: 1px solid #ebebeb;
}

.comment-btn {
  justify-content: space-between;
}

.send-comment {
  padding: 4px 10px;
}

.input-wrapper {
  margin-bottom: 4px;
}

.pagination-wrapper {
  margin: 5px 0;
  text-align: center;
}

.no-comment {
  line-height: 50px;
  text-align: center;
  color: #999;
}

.share-text {
  color: #999999;
  line-height: 30px;
}

.share-menu li {
  margin: 0 20px;
}

.share-menu a {
  display: block;
  height: 28px;
  padding-top: 42px;
  text-align: center;
  line-height: 32px;
  color: #999999;
  background-repeat: no-repeat;
}

.share-handlian {
  background-position: 10px 14px;
  background-image: url("../assets/icon/cl_share_handlian.png");
}

.share-menu a:hover {
  color: #1a70db;
}

.body-wrapper {
  overflow: hidden;
}

.feed-info {
  width: 93%;
  justify-content: space-between;
}

.name-wrapper {
  margin-left: 6px;
  line-height: 20px;
}

.name-wrapper .user-name {
  font-size: 16px;
  line-height: 30px;
}

.name-wrapper .create-time {
  color: #999;
}

.arrow-down-wrapper {
  width: 45px;
  height: 25px;
  display: inline-block;
  text-align: center;
  font-size: 17px;
  cursor: pointer;
}

.arrow-down-wrapper:hover {
  color: #ff6600;
}

.follow {
  padding: 4px 5px;
}

.report-tip {
  margin-left: 100px;
  margin-bottom: 10px;
}
</style>
